<template>
  <el-checkbox
    :value="checked"
    :indeterminate="isIndeterminate"
    @change="handleChange"
  >{{ value.node_name }}</el-checkbox>
</template>

<script>
export default {
  name: 'CheckBoxItem',
  props: {
    // 每一项数据
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 所有选中的id集合
    checkedIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 子项
    children: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isIndeterminate() {
      return this.ids.length > this.curCheckedIds.length && this.curCheckedIds.length > 0
    },
    curCheckedIds() {
      return this.checkedIds.filter(item => this.ids.includes(item))
    },
    ids() {
      return this.children.map(item => item.node_id)
    },
    checked() {
      // TODO：如果是三级联动开启注释
      // if (this.value.children) {
      //   return this.ids.every(item => this.checkedIds.includes(item))
      // }
      return this.checkedIds.includes(this.value.node_id)
    }
  },
  methods: {
    handleChange(checked) {
      if (checked) {
        // 包括自身和子项 core
        this.$emit('change', Array.from(new Set([...this.checkedIds, ...this.ids, this.value.node_id])))
      } else {
        // core
        const arr = this.checkedIds.filter(item => !this.ids.includes(item)).filter(list => list !== this.value.node_id)
        this.$emit('change', arr)
      }
    }
  }
}
</script>

<style>

</style>
